'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Content = require('./../../helpers/Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuburbanCamps = function (_Component) {
  (0, _inherits3.default)(SuburbanCamps, _Component);

  function SuburbanCamps() {
    (0, _classCallCheck3.default)(this, SuburbanCamps);
    return (0, _possibleConstructorReturn3.default)(this, (SuburbanCamps.__proto__ || (0, _getPrototypeOf2.default)(SuburbanCamps)).apply(this, arguments));
  }

  (0, _createClass3.default)(SuburbanCamps, [{
    key: 'render',
    value: function render() {
      var styles = require('./SuburbanCamps.scss');
      var photoIntro = require('./suburban-camps-intro.jpg');
      var photo1 = require('./suburban-camps1.jpg');
      var photo2 = require('./suburban-camps2.jpg');
      var photo3 = require('./suburban-camps3.jpg');

      var data = {
        dates: [{
          url: '/primestske-tabory/19.-23.8.2019',
          date: '19.-23.8.',
          rest: 0
        }, {
          url: '/primestske-tabory/26.-30.8.2019',
          date: '26.-30.8.',
          rest: 0
        }],
        intro: {
          text: 'Příměstské tábory pořádáme v okolí Prahy. Děti ráno vyzvedneme na Smíchovském nádraží a dovezeme do Třebotova, kde se setkáme s dětmi, které rodiče dovezou až na místo. Po dopoledním sportovním programu se přesuneme do restaurace na oběd a odpoledne bude ve znamení výtvarných činností a výletů. Tábor zvládne opravdu každý. Dbáme na to, aby se s námi bavili sportovní začátečníci i malí šampioni.',
          image: {
            src: photoIntro,
            alt: 'Příměstské tábory pro všechny'
          }
        },
        photos: {
          heading: 'Fotky z příměstských táborů',
          photo1: {
            src: photo1,
            alt: 'Sportovní příměstské tábory'
          },
          photo2: {
            src: photo2,
            alt: 'Letní příměstské tábory'
          },
          photo3: {
            src: photo3,
            alt: 'Příměstské tábory pro začátečníky i pokročilé'
          }
        }
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: 'P\u0159\xEDm\u011Bstsk\xE9 t\xE1bory, na kter\xFDch str\xE1v\xED va\u0161e d\u011Bti l\xE9to aktivn\u011B',
          meta: [{
            name: 'description',
            content: 'Příměstské sportovní tábory v okolí Prahy. Pro začátečníky i malé šampiony.'
          }, {
            property: 'og:description',
            content: 'Příměstské sportovní tábory v okolí Prahy. Pro začátečníky i malé šampiony.'
          }, {
            property: 'og:title',
            content: 'Příměstské tábory, na kterých stráví vaše děti léto aktivně'
          }, {
            name: 'keywords',
            content: 'příměstský tábor, příměstský sportovní tábor, příměstské sportovní tábory, letní tábor, letní tábory, letní tábory pro děti'
          }],
          link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz/primestske-tabory' }] }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'h1',
            null,
            'P\u0159\xEDm\u011Bstsk\xE9 t\xE1bory, ',
            _react2.default.createElement(
              'small',
              null,
              'na kter\xFDch str\xE1v\xED va\u0161e d\u011Bti l\xE9to aktivn\u011B'
            )
          ),
          _Content2.default.renderDates(styles, data.dates)
        ),
        _Content2.default.renderIntro(styles, data.intro),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _Content2.default.renderPhotos(styles, data.photos),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'chapter col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                'Co na t\xE1borech budeme d\u011Blat?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Po p\u0159\xEDjezdu do T\u0159ebotova budeme pilovat z\xE1klady atletick\xE9 p\u0159\xEDpravy, hr\xE1t m\xED\u010Dov\xE9 hry a hry v p\u0159\xEDrod\u011B. D\u011Bti se mohou t\u011B\u0161it i na plav\xE1n\xED a v Radot\xEDn\u011B si zabrusl\xEDme na in-line brusl\xEDch.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Po ob\u011Bd\u011B v restauraci zam\u011Bstn\xE1 d\u011Bti r\u016Fznorod\xE1 v\xFDtvarn\xE1 \u010Dinnost a po odpo\u010Dinku budou sout\u011B\u017Eit v t\xFDmech.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'chapter col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                'Na koho se t\u011B\u0161\xEDme?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'T\u011B\u0161\xEDme se na holky a kluky, kte\u0159\xED se s n\xE1mi cht\u011Bj\xED bavit a n\u011Bco se nau\u010Dit. Nikoho do ni\u010Deho nenut\xEDme, chceme, aby si d\u011Bti t\xE1bor u\u017Eily a nenudily se.'
              )
            )
          )
        ),
        _Content2.default.renderDates(styles, data.dates, true)
      );
    }
  }]);
  return SuburbanCamps;
}(_react.Component);

exports.default = SuburbanCamps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SuburbanCamps/SuburbanCamps.js
// module id = 1115
// module chunks = 0